import { Component, OnInit, input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-progress-spinner',
  templateUrl: './progress-spinner.component.html',
  styleUrls: ['./progress-spinner.component.css']
})
export class ProgressSpinnerComponent implements OnInit {

  public readonly diam = input<number>(35);

  constructor() { }

  ngOnInit(): void {
  }

}
